import Api, { WebApi } from "@/services/Api";

export async function socialLogin(provider) {
    return await Api().get(`/oauth/${provider}`);
}

export async function getCategories() {
    return await Api().get("/travel/categories");
}

export async function login(credentials) {
    return await WebApi().post("/login", credentials);
}

export async function forgetpassword(credentials) {
    return await Api().post("/forgot-password", credentials);
}

export async function sendVerificationEmail() {
    return await WebApi().post("/email/verification-notification");
}

export async function logoutSession() {
    return await WebApi().post("/logout");
}

export async function updateVerificationEmail(email = "") {
    return await Api().post(`/auth/verification-email/update`, { email });
}

export async function oAuthLogin(provider) {
    return await Api().get(`/oauth/${provider}`);
}

export async function switchAgency(payload) {
    return await Api().post("/switch-agency", payload);
}

export async function removeAgency() {
    return await Api().post("/remove-agency");
}
